import { render, staticRenderFns } from "./xeAreaSetting.vue?vue&type=template&id=287ff0c0"
import script from "./xeAreaSetting.vue?vue&type=script&lang=js"
export * from "./xeAreaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports